import React, { useEffect, useState } from 'react';
import { onepiecequizContent, loadLiveBoard } from '../rich-content/onepiecequiz-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const OnepiecequizDetailPage = () => {
  // render the saved snapshot at once, then re-render with the live board when it arrives
  const [, setLive] = useState(0);
  useEffect(() => { loadLiveBoard().then((ok) => { if (ok) setLive((n) => n + 1); }); }, []);
  return <AutomaticPageBuilder content={onepiecequizContent} />;
};

export default OnepiecequizDetailPage;
